<div class="reason-input-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <mat-dialog-content>
    <p class="dialog-message">{{ data.message }}</p>
    <form [formGroup]="reasonForm">
      <div class="form-group">
        <label for="reason">Reason <span class="required">*</span></label>
        <textarea 
          id="reason"
          formControlName="reason" 
          rows="5" 
          class="form-control"
          placeholder="Please provide a reason for requesting changes..."
          [class.is-invalid]="reasonForm.get('reason')?.invalid && reasonForm.get('reason')?.touched"></textarea>
        <div class="invalid-feedback" *ngIf="reasonForm.get('reason')?.hasError('required') && reasonForm.get('reason')?.touched">
          Reason is required
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="onCancel()">
      {{ data.cancelText }}
    </button>
    <button type="button" class="btn btn-primary" (click)="onConfirm()" [disabled]="!reasonForm.valid">
      <i class="fas fa-paper-plane me-2"></i>
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div>

